/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as action from './action'
import Employee from './component/employee'
import { Spin } from 'antd'
import { fetchRegionList } from '../ClubUsers/action'

const actions = {
  ...action,
  fetchRegionList,
}
class ClubEmployee extends React.Component {
  static defaultProps = {
    employeeList: [],
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    if (!this.props.regionList) this.props.fetchRegionList()
    this.props.fetchEmployeeList().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { employeeList, regionList } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Employee
            list={employeeList}
            regionList={regionList}
            fetchEditEmployee={this.props.fetchEditEmployee}
            fetchDelEmployee={this.props.fetchDelEmployee}
            fetchAddEmployee={this.props.fetchAddEmployee}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    employeeList: state.getClubEmployee.employeeList,
    regionList: state.getClubUsers.regionList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubEmployee))



// WEBPACK FOOTER //
// ./src/containers/ClubEmployee/index.js